/* eslint-disable prettier/prettier */
/* eslint-disable max-classes-per-file */

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.init()
    }

    init() {
      this.form = this.querySelector('form');

      this.form.querySelector('[name=id]').disabled = false;

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartItems = document.querySelector('cart-items');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');

      // this is to counter Autocart app's enabling custom sold out buttons
      this.enforceSoldOutState();   
    }

    enforceSoldOutState() {                                                                                                                                                     
      if (!this.submitButton) return;
      const isSoldOutText = () => {                                                                                                                                             
        const span = this.submitButton.querySelector('span');
        if (!span) return false;                                                                                                                                                
        const t = span.textContent.trim().toLowerCase();
        return t === 'sold out' || t === 'unavailable';                                                                                                                         
      };                                                                                                                                                                        
      const reassert = () => {
        if (isSoldOutText() && !this.submitButton.hasAttribute('disabled')) {                                                                                                   
          this.submitButton.setAttribute('disabled', 'disabled');                                                                                                               
        }                                                                                                                                                                       
      };                                                                                                                                                                        
      reassert();                                                                                                                                                               
      new MutationObserver(reassert).observe(this.submitButton, {
        attributes: true,
        attributeFilter: ['disabled'],                                                                                                                                          
        childList: true,
        subtree: true,                                                                                                                                                          
        characterData: true,
      });
    }

    onSubmitHandler(evt) {
      evt.preventDefault(this.form);
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      // this.cartItems.setActiveElement(document.activeElement);

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if( this.submitButton.closest('.custom-form-container') ){
        const customFormContainer = this.submitButton.closest('.custom-form-container');
        const quantity = customFormContainer.querySelector('.quantity__input').value;
        formData.append('quantity', quantity);  
      }
      
      formData.append('sections', this.cartItems.getSectionsToRender().map((section) => section.id).join(','));
      formData.append('sections_url', `${Shopify.routes.root}cart`);
      config.body = formData;
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then(
          function(json) {
            if (json.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: json.errors || json.description,
                message: json.message,
              });
          
              var gift_card_recipient_control_flag = document.querySelector('input[name="properties[__shopify_send_gift_card_to_recipient]"]');
              
              // Gift Card has it's own error handling functions on recipient-form.js
              if( gift_card_recipient_control_flag == null ){
                this.handleErrorMessage(json.description);
              }

              if ( json.errors ){
                this.error = true;
              }

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            this.error = false;

            if (window.oaiq) {
              window.oaiq("measure", "items_added", {
                type: "contents",
                amount: json.price * json.quantity,
                currency: "USD",
                contents: [{
                  id: json.sku || String(json.variant_id),
                  name: json.product_title,
                  content_type: "product",
                  quantity: json.quantity,
                  amount: json.price * json.quantity,
                  currency: "USD"
                }]
              });
            }

            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: json });
          

            const cartProgressBar = document.querySelector('cart-progress-bar')
            if (cartProgressBar) {
              this.cartItems.updateCart(function() {
                cartProgressBar.addRemoveProgressProducts()
              })
            }
           
          }.bind(this))
          .catch((e) => {
            console.error(e);
          })
          .finally(function() {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');

            this.constructor.handleCustomAddToCart()

            if( !this.error ){
              const stickyHeader = document.querySelector('sticky-header')
              if (stickyHeader) {
                stickyHeader.reveal()
              }
  
              setTimeout(function() {
                const quickAddModal = this.submitButton.closest('quick-add-modal')
                if (quickAddModal) {
                  quickAddModal.hide()
                }
                if(this.cartDrawer) {
                  this.cartDrawer.openMenuDrawer()
                }
              }.bind(this), 66);
            }
            
          }.bind(this));
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
     
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
     
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    static handleCustomAddToCart() {
      // This function is for classic-evolve-atc section, which has a custom add to cart button outside of the form. It will trigger the form submission when clicked.
      const customAddToCartButton = document.querySelector('.add-to-cart-container.loading');
      if (!customAddToCartButton) return;

      const button = customAddToCartButton.querySelector('.custom-submit-btn');
      const spinner = customAddToCartButton.querySelector('.loading-overlay__spinner');

      if (button && spinner) {
        button.classList.remove('disabled');
        button.removeAttribute('disabled');
        spinner.classList.add('hidden');
      }
    }
  });
}
